import React from "react";
import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";
import BowlerRow from "./BowlerRow";

const thClass =
  "px-4 py-2 text-left text-xs font-display font-bold tracking-wider uppercase text-brand-cream bg-brand-charcoal";

const SortableTh = ({ label, field, sortBy, sortOrder, onSort, align = "left" }) => {
  const active = sortBy === field;
  const Icon =
    !active ? FaSort : sortOrder === "asc" ? FaSortUp : FaSortDown;

  return (
    <th className={`${thClass} ${align === "right" ? "text-right" : ""}`}>
      <button
        type="button"
        onClick={() => onSort(field)}
        className={`inline-flex items-center gap-1.5 hover:text-brand-gold ${
          align === "right" ? "ml-auto" : ""
        }`}
        aria-sort={
          active ? (sortOrder === "asc" ? "ascending" : "descending") : "none"
        }
      >
        {label}
        <Icon className={`h-3 w-3 ${active ? "text-brand-gold" : "opacity-50"}`} />
      </button>
    </th>
  );
};

const DesktopTable = ({
  tournamentBowlers,
  emptyMessage,
  canManageAndLoggedIn,
  editingBowlerId,
  editedAverage,
  editedHasAverage,
  errorMessage,
  verifyingBowlerId,
  verifyingAll,
  onEditClick,
  onAverageChange,
  onSaveClick,
  onCancelClick,
  onVerifyClick,
  onHasAverageChange,
  onUseCatalogAverage,
  onReview,
  canVerifyBowlerForEdit,
  canUnverifyBowlerForEdit,
  sortBy,
  sortOrder,
  onSortChange,
}) => {
  const columnCount = canManageAndLoggedIn ? 5 : 4;

  return (
    <div className="hidden md:block overflow-x-auto">
      <table className="min-w-full divide-y divide-brand-charcoal/10">
        <thead className="bg-brand-charcoal">
          <tr>
            <SortableTh
              label="First name"
              field="firstName"
              sortBy={sortBy}
              sortOrder={sortOrder}
              onSort={onSortChange}
            />
            <SortableTh
              label="Last name"
              field="lastName"
              sortBy={sortBy}
              sortOrder={sortOrder}
              onSort={onSortChange}
            />
            <SortableTh
              label="Average"
              field="average"
              sortBy={sortBy}
              sortOrder={sortOrder}
              onSort={onSortChange}
            />
            <th className={thClass}>Status</th>
            {canManageAndLoggedIn && (
              <th className={`${thClass} text-right`}>Actions</th>
            )}
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-brand-charcoal/10">
          {tournamentBowlers.bowlerData.length === 0 ? (
            <tr>
              <td
                colSpan={columnCount}
                className="px-4 py-8 text-sm text-brand-muted text-center"
              >
                {emptyMessage}
              </td>
            </tr>
          ) : (
            tournamentBowlers.bowlerData.map((bowler) => (
              <BowlerRow
                key={bowler.bowlerId}
                bowler={bowler}
                isEditing={editingBowlerId === bowler.bowlerId}
                editedAverage={editedAverage}
                errorMessage={errorMessage}
                canManage={canManageAndLoggedIn}
                verifyingBowlerId={verifyingBowlerId}
                verifyingAll={verifyingAll}
                onEditClick={onEditClick}
                onAverageChange={onAverageChange}
                onSaveClick={onSaveClick}
                onCancelClick={onCancelClick}
                onVerifyClick={onVerifyClick}
                onHasAverageChange={onHasAverageChange}
                onUseCatalogAverage={onUseCatalogAverage}
                onReview={onReview}
                canVerify={
                  canVerifyBowlerForEdit
                    ? canVerifyBowlerForEdit(bowler.bowlerId)
                    : false
                }
                canUnverify={
                  canUnverifyBowlerForEdit
                    ? canUnverifyBowlerForEdit(bowler.bowlerId)
                    : false
                }
                editedHasAverage={editedHasAverage}
              />
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default DesktopTable;
